<div class="relative flex h-min p-1" [matTooltip]="tooltipKey | transloco">
  <mat-icon class="material-icons-outlined hvs-icon-lg"> link </mat-icon>
  <div
    class="absolute right-0 top-0 flex items-center justify-center rounded-full border border-white p-px"
    [class]="badgeColor"
  >
    <mat-icon class="material-icons-outlined hvs-icon-xxs text-white">
      {{ badgeIcon }}
    </mat-icon>
  </div>
</div>
